import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { HourglassSVG } from '@common_components/svg/hourglass.svg';

const HourglassIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <HourglassSVG/>
    </div>
  );
};

export { HourglassIcon };
